export enum TradePageLinkKeys {
  je = 'je',
  haAdmin = 'haAdmin',
  pricer = 'pricer',
  tradeDetails = 'tradeDetails',
}
